<template>
  <v-main>
    <v-container fluid class="custom">
      <router-view :key="$route.path" />
    </v-container>
    <alert />
    <material-snackbar
      v-for="(snackbar, index) in snackbars.filter(s => s.showing)"
      :key="snackbar.text + Math.random()"
      v-model="snackbar.showing"
      :timeout="snackbar.timeout"
      :type="snackbar.type"
      :style="`bottom: ${(index * 100) + 8}px`"
      v-bind="{
        'bottom': true,
        'center': true
      }"
    >
      {{ $t(snackbar.text) }}
    </material-snackbar>
    <v-overlay
      :value="loading"
    >
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
  </v-main>
</template>

<script>
  import Alert from '@/components/Alert'
  import MaterialSnackbar from '@/components/MaterialSnackbar'
  import { call, get } from 'vuex-pathify'

  export default {
    name: 'DefaultView',
    components: {
      MaterialSnackbar,
      Alert,
    },
    computed: {
      snackbars: get('alert/snackbars'),
      loading: get('app/loading'),
    },
    methods: {
      setAlert: call('alert/setSnackbar'),
    },
  }
</script>

<style lang="sass">
@media #{map-get($display-breakpoints, 'sm-and-down')}
  .custom
    margin-bottom: 100px
</style>
